// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__qLUTk","title":"HeroContent_title__sf59M","description":"HeroContent_description__GQGcZ","control":"HeroContent_control__gNgFH"};